import type { AccessLevel } from '@/shared/access';

/**
 * How a level is coloured wherever it appears as a chip.
 *
 * <p>One table so the ladder reads the same on every screen — a reviewer who has learned that the
 * secondary-coloured chip means "administrator" on the department list must not have to relearn it on the
 * employee list. Colour is never the only carrier: every chip is labelled with the level's own name.
 */
export const LEVEL_COLOR: Record<AccessLevel, 'default' | 'info' | 'primary' | 'secondary'> = {
  NONE: 'default',
  VIEW: 'info',
  EDIT: 'primary',
  ADMIN: 'secondary',
};
